import { Button, Modal, notification } from "antd";
import { useDispatch, useSelector } from "react-redux";
import React, { useContext, useEffect, useRef, useState } from "react";
import CustomForm from "../CustomForm";
import { userHasLevel } from "../../../engine/AuthRoute";
import { roles, statusPrestationsValues } from "../../../utils/constants";
import { createPortal } from "react-dom";
import { modalsByContext } from "./modals";
import {
  setPropertiesPrestation,
  updateAdminPrestation,
} from "../../../pages/Prestations/Slices/Prestation.slice";
import { ModalContext } from "../../../engine/context/Modal.provider";
import { UserContext } from "../../../engine/context/User.context";
import { FiCheckCircle } from "react-icons/fi";
import { AddresseItem } from "../../container/Addresses/AddresseItem/AddresseItem";
import {
  isCheckedAddress,
  typeAddress,
} from "../../container/Addresses/AddresseItem/AddresseHelpers";
import { inputsAddresseItem } from "../../container/Addresses/AddresseItem/AddresseItemInputs";
import { newAddresse } from "../../container/Addresses/AddressesSlice/Addresses.slice";
import { addresseItemMapsInputs } from "../../container/Addresses/AddresseItem/AddresseItemMapsInputs";
import { truncateDecimal } from "../../../utils/helpersFunction";

export const InstitutionNewAddress = ({ defaultOpen }) => {
  const [open, setOpen] = useState(defaultOpen);

  useEffect(() => {
    setOpen(defaultOpen);
  }, [defaultOpen]);

  const { institution } = useSelector(state => state.institution);
  const { user } = useContext(UserContext);

  const formRef = useRef(null);

  const context = useContext(ModalContext);
  const { params } = context;
  const { type } = params;
  const dispatch = useDispatch();
  const close = params => {
    setOpen(false);
    context.closeModal(modalsByContext.InstitutionNewAddress, params);
  };
  const onSubmitForm = async data => {
    const allDatas = formRef.current.getFieldsValue(true);
    let payload = {};

    // handleSubmit(generateSubObject(values), form);

    if (type === typeAddress.postal) {
      payload = {
        type,
        institution: params?.institution,
        principal: params?.principal,
        description: data?.description,
        ...data?.address,
        sharedToInstitutions: data?.sharedToInstitutions || [],
      };
    }

    if (type === typeAddress.maps) {
      const allData = formRef.current.getFieldsValue(true);
      let longitude = "";
      let latitude = "";
      let canton = "";

      if (data.maps !== undefined) {
        longitude = truncateDecimal(allData?.lng_maps || 0, 5);
        latitude = truncateDecimal(allData?.lat_maps || 0, 5);
        canton = allData?.canton_maps || "";
      }

      payload = {
        type,
        institution: params?.institution,
        ...data,
        longitude,
        latitude,
        canton,
      };
    }
    console.log(payload, allDatas, data);
    let action = await dispatch(newAddresse(payload));

    close({ _id: action?.payload?._id, data: action?.payload });
  };

  const config = {
    key: institution._id + modalsByContext.InstitutionNewAddress,
    containerStyle: { minWidth: "500px" },
    title:
      type === typeAddress.postal
        ? "Nouvelle adresse de facturation"
        : "Nouveau lieu d'intervention",
    open: open,
    width: 1000,
    onOk: () => {
      formRef.current.submit();
    },
    onCancel: close,
    content: (
      <>
        <CustomForm
          refForm={formRef}
          dataSource={
            type === typeAddress.postal
              ? inputsAddresseItem({
                  address: {
                    beneficiary: "",
                  },
                  description: ``,
                })
              : addresseItemMapsInputs({
                  location: "",
                  maps: "",
                })
          }
          labelCol={24}
          handleSubmit={onSubmitForm}
          wrapperCol={24}
        />
      </>
    ),
    footer: [
      <Button key="close" onClick={close}>
        Fermer
      </Button>,
      <Button
        icon={<FiCheckCircle size={20} />}
        type="primary"
        // loading={loadingEdit}
        // disabled={loadingEdit}
        onClick={async () => {
          try {
            const test = await formRef.current.validateFields();
            formRef.current.submit();
          } catch (e) {
            notification.error({
              message: e.errorFields.length + " champs est nécessaire",
            });
          }
        }}
      >
        {type === typeAddress.postal && "Créer l'adresse"}
        {type === typeAddress.maps && "Créer le lieu d'intervention"}
      </Button>,
    ],
  };

  return (
    <>
      {createPortal(
        <Modal {...config}>{config.content}</Modal>,
        document.querySelector("#modals"),
      )}
    </>
  );
};

export const prestationCommentAdminInputs = prestation => {
  const {
    intervention: { startDate, endDate, location, extra },
    comment,
  } = prestation;

  return [
    {
      hidden: !userHasLevel({
        only: {
          [roles.admin]: "crud", //
          [roles.permanance]: "crud", //
        },
      }),
      children: [
        {
          label: "Commentaire permanence",
          name: "comment.admin",
          hidden: !userHasLevel({
            only: {
              [roles.admin]: "crud", //
              [roles.permanance]: "crud", //
            },
          }),
          value: comment.admin,
          type: "textarea",
          row: 2,
          col: 24,
        },
      ],
    },
  ];
};
